export default "__VITE_ASSET__DJ7qdK2u__"